import { logEvent } from "firebase/analytics";
import { config } from "./config";
import { getAnalyticsSafe } from "./firebase";

// set conservative consent mode defaults (ads off, analytics on)
export async function initConsentDefaults() {
  await getAnalyticsSafe();
  (window as any).gtag?.("consent", "default", {
    ad_user_data: "denied",
    ad_personalization: "denied",
    ad_storage: "denied",
    analytics_storage: "granted",
  });
}

// turn off signas and ad personlization globally
export async function hardenAnalyticsConfig() {
  await getAnalyticsSafe();
  (window as any).gtag?.("config", config.FIREBASE_MEASUREMENT_ID, {
    allow_google_signals: false,
    allow_ad_personalization_signals: false,
  });
}

// (optional): runtime kill switch for sensitive routes
export async function setAnalyticsEnabled(enabled: boolean) {
  const { setAnalyticsCollectionEnabled } = await import("firebase/analytics");
  const analytics = await getAnalyticsSafe();
  if (analytics) setAnalyticsCollectionEnabled(analytics, enabled);
}

export async function trackEvent(name: string, params?: Record<string, any>) {
  const analytics = await getAnalyticsSafe();
  if (analytics) logEvent(analytics, name, params);
}
